
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#E5E5E5","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"fill":"#fff","d":"M-34-254h1440V945H-34z"}}),_c('path',{staticClass:"toFill",attrs:{"d":"M17.64 12a5.64 5.64 0 11-11.28 0 5.64 5.64 0 0111.28 0z","fill":"#042132"}}),_c('path',{staticClass:"toFill",attrs:{"d":"M12 1.32C6.102 1.32 1.32 6.102 1.32 12 1.32 17.9 6.102 22.68 12 22.68 17.9 22.68 22.68 17.9 22.68 12 22.68 6.102 17.9 1.32 12 1.32zm0 18.72a8.04 8.04 0 11.001-16.08 8.04 8.04 0 010 16.08z","fill":"#042132"}})])
          )
        }
      }
    